<template>
  <v-layout column>
    <v-menu
      v-model="filterMenu"
      :close-on-content-click="false"
      bottom
      :nudge-bottom="35"
    >
      <template v-slot:activator="{ on: menu }">
        <ToolbarIconButton
          :icon="'filter_list'"
          :tooltip="'Выбрать Фильтр'"
          data-test="filterButton"
          :is-right-position="true"
          :icon-color="selected ? 'primary' : ''"
          v-on="{ ...menu }"
        />
      </template>
      <v-card width="500">
        <v-card-title class="py-0">
          <h2 class="title my-3">
            Фильтр
          </h2>
        </v-card-title>
        <v-card-text class="py-0">
          <v-layout>
            <v-select
              v-model="selected"
              :items="savedFilters"
              label="Сохранённые фильтры"
              hide-details
              item-text="title"
              item-value="id"
              return-object
              menu-props="offsetY"
              no-data-text="Данных нет"
              outline
              clearable
              @input="getSavedFilter"
            >
              <template v-slot:selection="data">
                <span :selected="data.selected">
                  {{ data.item.title }}
                </span>
              </template>
              <template v-slot:item="data">
                <template>
                  <v-list-tile-content v-text="data.item.title" />
                </template>
              </template>
            </v-select>
            <v-btn
              v-if="selected"
              icon
              small
              class="my-2"
              @click="deleteFilter(selected)"
            >
              <v-icon color="grey darken-1">
                delete
              </v-icon>
            </v-btn>
          </v-layout>
        </v-card-text>
        <v-card-actions class="py-3">
          <v-spacer />
          <SaveBtn @click="apply" />
          <CancelBtn @click="closeFilterMenu" />
        </v-card-actions>
      </v-card>
    </v-menu>
    <v-menu
      v-model="saveMenu"
      :close-on-content-click="false"
      bottom
      :nudge-bottom="35"
    >
      <template v-slot:activator="{ on: menu }">
        <ToolbarIconButton
          :icon="'save'"
          :tooltip="'Сохранить/Изменить Фильтр'"
          data-test="filterButton"
          :is-right-position="true"
          v-on="{ ...menu }"
        />
      </template>
      <v-card>
        <v-card-text>
          <v-text-field
            v-model="filterTitle"
            label="Имя фильтра"
            outline
            hide-details
            height="44"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            flat
            small
            @click="saveFilter"
          >
            Сохранить
          </v-btn>
          <CancelBtn @click="closeSaveMenu" />
        </v-card-actions>
      </v-card>
    </v-menu>
  </v-layout>
</template>
<script>
import ToolbarIconButton from "../../../components/ToolbarIconButton.vue";
import * as dataListApi from "../../../backend/dataListApi.js";
export default {
  components: { ToolbarIconButton },
  data() {
    return {
      filterMenu: false,
      selected: null,
      saveMenu: false,
      filterTitle: "",
      filter: null,
      resource: "routePlanningItems",
    };
  },
  computed: {
    shippingState() {
      return this.$store.getters["routePlanning/shippingState"];
    },
    phaseType() {
      return this.$store.getters["routePlanning/phaseType"];
    },
    directions() {
      return this.$store.getters["routePlanning/directions"];
    },
    destinationCountries() {
      return this.$store.getters["routePlanning/destinationCountries"];
    },
    sendingCountries() {
      return this.$store.getters["routePlanning/sendingCountries"];
    },
    savedFilters() {
      return this.$store.getters["routePlanning/savedPlanningFilters"];
    },
    storeFilter() {
      return this.$store.getters["routePlanning/planningFilter"];
    },
    planningQuickFilter() {
      return this.$store.getters["routePlanning/planningQuickFilter"];
    },
  },
  watch: {
    selected(value) {
      if (value) {
        this.filterTitle = value.title;
      }
      if (!value) {
        this.filterTitle = "";
        this.filter = null;
      }
    },
  },
  created() {
    this.getSavedFilters();
    this.filter = this.storeFilter ? { ...this.storeFilter } : null;
    this.selected = this.planningQuickFilter
      ? { ...this.planningQuickFilter }
      : null;
  },
  methods: {
    async getSavedFilters() {
      await this.$store.dispatch("routePlanning/getSavedPlanningFilters");
    },
    async getSavedFilter(filter) {
      if (filter) {
        const res = await dataListApi.getSavedFilter(filter.id);
        this.filter = res.data.Filter;
      } else {
        this.filter = null;
      }
    },
    apply() {
      this.$store.commit(
        "routePlanning/setDirections",
        this.filter?.countries || [],
      );
      this.$store.commit(
        "routePlanning/setDestinationCountries",
        this.filter?.destinationCountries || [],
      );
      this.$store.commit(
        "routePlanning/setSendingCountries",
        this.filter?.sendingCountries || [],
      );
      this.$store.commit(
        "routePlanning/setShippingState",
        this.filter?.shippingPlacingType || null,
      );
      this.$store.commit(
        "routePlanning/setPhaseType",
        this.filter?.shippingDeliveryType || null,
      );
      this.$store.commit("routePlanning/setFilterIsActive", true);
      this.$store.commit("routePlanning/setPlanningFilter", this.filter);
      this.$store.commit("routePlanning/setPlanningQuickFilter", this.selected);

      this.$emit("changeFilter");
      this.filterMenu = false;
    },
    async saveFilter() {
      this.filter = {
        countries: this.directions,
        destinationCountries: this.destinationCountries,
        sendingCountries: this.sendingCountries,
        shippingPlacingType: this.shippingState,
        shippingDeliveryType: this.phaseType,
      };
      const filter = {
        title: this.filterTitle,
        filter: this.filter,
        page: this.resource,
        isShared: false,
      };
      if (this.selected) {
        await dataListApi.updateSavedFilter(this.selected.id, filter);
        await this.getSavedFilters();
        this.selected = this.savedFilters.find(
          f => f.title === this.filterTitle,
        );
        this.$store.commit("routePlanning/setPlanningFilter", this.filter);
        this.$store.commit(
          "routePlanning/setPlanningQuickFilter",
          this.selected,
        );
        this.showInfo("Фильтр изменён");
        this.saveMenu = false;
      } else {
        await dataListApi.createSavedFilter(filter);
        await this.getSavedFilters();
        this.selected = this.savedFilters.find(
          f => f.title === this.filterTitle,
        );
        this.$store.commit("routePlanning/setPlanningFilter", this.filter);
        this.$store.commit(
          "routePlanning/setPlanningQuickFilter",
          this.selected,
        );
        this.saveMenu = false;
        this.showInfo("Фильтр добавлен");
      }
    },
    async deleteFilter(filter) {
      if (confirm("Удалить фильтр?")) {
        await dataListApi.deleteSavedFilter(this.resource, filter.id);
        this.filter = null;
        this.selected = null;
        this.$store.commit("routePlanning/setPlanningFilter", this.filter);
        this.$store.commit(
          "routePlanning/setPlanningQuickFilter",
          this.selected,
        );
        await this.getSavedFilters();
      }
    },
    closeFilterMenu() {
      if (!this.storeFilter) {
        this.selected = null;
        this.filter = null;
      } else {
        this.selected = this.planningQuickFilter;
        this.filter = this.storeFilter;
      }
      this.filterMenu = false;
    },
    closeSaveMenu() {
      if (!this.storeFilter) {
        this.selected = null;
        this.filter = null;
      } else {
        this.filterTitle = this.planningQuickFilter?.title || "";
        this.selected = this.planningQuickFilter;
        this.filter = this.storeFilter;
      }
      this.saveMenu = false;
    },
  },
};
</script>
